import { getProducts } from "@/apis/shop-api";
import ErrorPage from "@/components/ErrorPage";
import ShopSkeleton from "../../components/skeletons/ShopSkeleton";
import { ShopContext } from "@/contexts/shop-context";
import type { ChildrenType } from "@/types/types";
import { useContext, useEffect, useState } from "react";

export default function ShopContextPage({ children }: ChildrenType) {
    const { product, setProduct, setCategory } = useContext(ShopContext);
    const [isLoading, setIsLoading] = useState(!product);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getProducts();
                setProduct(res.products);
                setCategory(res.categories);
            } catch (error) {
                console.error("Failed get products:", error);
                setError(true);
            } finally {
                setIsLoading(false);
            }
        };
        if (!product) {
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) return <ShopSkeleton />;
    if (error) return <ErrorPage />;

    return <>{children}</>;
}
